interface Props {
  className?: string;
}

export default function DocumentsIcon({className}: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 19 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 0H5C4.46957 0 3.96086 0.210714 3.58579 0.585786C3.21071 0.960859 3 1.46957 3 2V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H17C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18V6L13 0ZM17 18H5V2H12V7H17V18Z"
        fill="currentColor"
      />
      <path
        d="M1.5 7V6.5H0.5V7H1.5ZM0.5 22C0.5 22.2761 0.723858 22.5 1 22.5C1.27614 22.5 1.5 22.2761 1.5 22H0.5ZM0.5 7L0.5 22H1.5L1.5 7H0.5Z"
        fill="currentColor"
      />
      <path
        d="M1 21.5C0.723858 21.5 0.5 21.7239 0.5 22C0.5 22.2761 0.723858 22.5 1 22.5V21.5ZM12 22.5H12.5V21.5H12V22.5ZM1 22.5H12V21.5H1V22.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
